export default [
  {
  "id": 313330998,
  "node_id": "MDEwOlJlcG9zaXRvcnkzMTMzMzA5OTg=",
  "name": "50projects50days",
  "full_name": "bradtraversy/50projects50days",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/50projects50days",
  "description": "50+ mini web projects using HTML, CSS & JS",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/50projects50days",
  "forks_url": "https://api.github.com/repos/bradtraversy/50projects50days/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/50projects50days/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/50projects50days/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/50projects50days/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/50projects50days/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/50projects50days/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/50projects50days/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/50projects50days/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/50projects50days/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/50projects50days/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/50projects50days/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/50projects50days/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/50projects50days/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/50projects50days/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/50projects50days/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/50projects50days/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/50projects50days/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/50projects50days/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/50projects50days/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/50projects50days/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/50projects50days/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/50projects50days/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/50projects50days/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/50projects50days/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/50projects50days/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/50projects50days/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/50projects50days/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/50projects50days/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/50projects50days/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/50projects50days/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/50projects50days/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/50projects50days/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/50projects50days/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/50projects50days/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/50projects50days/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/50projects50days/deployments",
  "created_at": "2020-11-16T14:39:01Z",
  "updated_at": "2021-11-28T08:55:03Z",
  "pushed_at": "2021-10-20T07:09:08Z",
  "git_url": "git://github.com/bradtraversy/50projects50days.git",
  "ssh_url": "git@github.com:bradtraversy/50projects50days.git",
  "clone_url": "https://github.com/bradtraversy/50projects50days.git",
  "svn_url": "https://github.com/bradtraversy/50projects50days",
  "homepage": null,
  "size": 489,
  "stargazers_count": 10058,
  "watchers_count": 10058,
  "language": "CSS",
  "has_issues": false,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 2756,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 32,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 2756,
  "open_issues": 32,
  "watchers": 10058,
  "default_branch": "master"
  },
  {
  "id": 154967708,
  "node_id": "MDEwOlJlcG9zaXRvcnkxNTQ5Njc3MDg=",
  "name": "A-to-Z-Resources-for-Students",
  "full_name": "bradtraversy/A-to-Z-Resources-for-Students",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/A-to-Z-Resources-for-Students",
  "description": "Curated list of resources for college students :octocat: If you like give a :star:",
  "fork": true,
  "url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students",
  "forks_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/A-to-Z-Resources-for-Students/deployments",
  "created_at": "2018-10-27T13:30:05Z",
  "updated_at": "2021-11-27T18:00:38Z",
  "pushed_at": "2019-10-08T18:51:01Z",
  "git_url": "git://github.com/bradtraversy/A-to-Z-Resources-for-Students.git",
  "ssh_url": "git@github.com:bradtraversy/A-to-Z-Resources-for-Students.git",
  "clone_url": "https://github.com/bradtraversy/A-to-Z-Resources-for-Students.git",
  "svn_url": "https://github.com/bradtraversy/A-to-Z-Resources-for-Students",
  "homepage": "https://gitter.im/a2z-resources",
  "size": 2546,
  "stargazers_count": 304,
  "watchers_count": 304,
  "language": null,
  "has_issues": false,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 136,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": {
  "key": "mit",
  "name": "MIT License",
  "spdx_id": "MIT",
  "url": "https://api.github.com/licenses/mit",
  "node_id": "MDc6TGljZW5zZTEz"
  },
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 136,
  "open_issues": 2,
  "watchers": 304,
  "default_branch": "master"
  },
  {
  "id": 96554809,
  "node_id": "MDEwOlJlcG9zaXRvcnk5NjU1NDgwOQ==",
  "name": "a4app",
  "full_name": "bradtraversy/a4app",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/a4app",
  "description": "Angular 4 in 60 Minutes app",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/a4app",
  "forks_url": "https://api.github.com/repos/bradtraversy/a4app/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/a4app/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/a4app/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/a4app/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/a4app/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/a4app/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/a4app/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/a4app/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/a4app/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/a4app/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/a4app/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/a4app/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/a4app/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/a4app/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/a4app/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/a4app/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/a4app/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/a4app/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/a4app/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/a4app/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/a4app/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/a4app/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/a4app/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/a4app/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/a4app/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/a4app/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/a4app/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/a4app/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/a4app/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/a4app/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/a4app/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/a4app/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/a4app/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/a4app/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/a4app/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/a4app/deployments",
  "created_at": "2017-07-07T16:03:26Z",
  "updated_at": "2021-09-29T03:22:54Z",
  "pushed_at": "2017-08-05T15:17:23Z",
  "git_url": "git://github.com/bradtraversy/a4app.git",
  "ssh_url": "git@github.com:bradtraversy/a4app.git",
  "clone_url": "https://github.com/bradtraversy/a4app.git",
  "svn_url": "https://github.com/bradtraversy/a4app",
  "homepage": null,
  "size": 14,
  "stargazers_count": 82,
  "watchers_count": 82,
  "language": "TypeScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 52,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 52,
  "open_issues": 2,
  "watchers": 82,
  "default_branch": "master"
  },
  {
  "id": 81346555,
  "node_id": "MDEwOlJlcG9zaXRvcnk4MTM0NjU1NQ==",
  "name": "acme_keystone",
  "full_name": "bradtraversy/acme_keystone",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/acme_keystone",
  "description": "Sample Keystone.js app with products",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/acme_keystone",
  "forks_url": "https://api.github.com/repos/bradtraversy/acme_keystone/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/acme_keystone/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/acme_keystone/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/acme_keystone/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/acme_keystone/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/acme_keystone/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/acme_keystone/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/acme_keystone/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/acme_keystone/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/acme_keystone/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/acme_keystone/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/acme_keystone/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/acme_keystone/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/acme_keystone/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/acme_keystone/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/acme_keystone/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/acme_keystone/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/acme_keystone/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/acme_keystone/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/acme_keystone/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/acme_keystone/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/acme_keystone/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/acme_keystone/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/acme_keystone/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/acme_keystone/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/acme_keystone/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/acme_keystone/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/acme_keystone/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/acme_keystone/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/acme_keystone/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/acme_keystone/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/acme_keystone/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/acme_keystone/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/acme_keystone/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/acme_keystone/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/acme_keystone/deployments",
  "created_at": "2017-02-08T15:52:12Z",
  "updated_at": "2021-09-20T15:23:22Z",
  "pushed_at": "2017-02-08T15:55:26Z",
  "git_url": "git://github.com/bradtraversy/acme_keystone.git",
  "ssh_url": "git@github.com:bradtraversy/acme_keystone.git",
  "clone_url": "https://github.com/bradtraversy/acme_keystone.git",
  "svn_url": "https://github.com/bradtraversy/acme_keystone",
  "homepage": null,
  "size": 469,
  "stargazers_count": 22,
  "watchers_count": 22,
  "language": "CSS",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 10,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 10,
  "open_issues": 0,
  "watchers": 22,
  "default_branch": "master"
  },
  {
  "id": 111341681,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMTEzNDE2ODE=",
  "name": "adonis40blog",
  "full_name": "bradtraversy/adonis40blog",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/adonis40blog",
  "description": "Simple blog in AdonisJS 4.0",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/adonis40blog",
  "forks_url": "https://api.github.com/repos/bradtraversy/adonis40blog/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/adonis40blog/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/adonis40blog/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/adonis40blog/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/adonis40blog/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/adonis40blog/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/adonis40blog/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/adonis40blog/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/adonis40blog/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/adonis40blog/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/adonis40blog/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/adonis40blog/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/adonis40blog/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/adonis40blog/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/adonis40blog/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/adonis40blog/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/adonis40blog/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/adonis40blog/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/adonis40blog/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/adonis40blog/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/adonis40blog/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/adonis40blog/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/adonis40blog/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/adonis40blog/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/adonis40blog/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/adonis40blog/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/adonis40blog/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/adonis40blog/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/adonis40blog/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/adonis40blog/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/adonis40blog/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/adonis40blog/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/adonis40blog/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/adonis40blog/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/adonis40blog/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/adonis40blog/deployments",
  "created_at": "2017-11-19T23:46:36Z",
  "updated_at": "2021-11-18T22:16:21Z",
  "pushed_at": "2017-11-19T23:51:10Z",
  "git_url": "git://github.com/bradtraversy/adonis40blog.git",
  "ssh_url": "git@github.com:bradtraversy/adonis40blog.git",
  "clone_url": "https://github.com/bradtraversy/adonis40blog.git",
  "svn_url": "https://github.com/bradtraversy/adonis40blog",
  "homepage": null,
  "size": 135,
  "stargazers_count": 24,
  "watchers_count": 24,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 18,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 18,
  "open_issues": 0,
  "watchers": 24,
  "default_branch": "master"
  },
  {
  "id": 24938686,
  "node_id": "MDEwOlJlcG9zaXRvcnkyNDkzODY4Ng==",
  "name": "aioweb",
  "full_name": "bradtraversy/aioweb",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/aioweb",
  "description": "Full featured CMS written in PHP and Codeigniter framework",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/aioweb",
  "forks_url": "https://api.github.com/repos/bradtraversy/aioweb/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/aioweb/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/aioweb/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/aioweb/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/aioweb/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/aioweb/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/aioweb/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/aioweb/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/aioweb/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/aioweb/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/aioweb/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/aioweb/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/aioweb/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/aioweb/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/aioweb/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/aioweb/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/aioweb/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/aioweb/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/aioweb/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/aioweb/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/aioweb/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/aioweb/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/aioweb/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/aioweb/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/aioweb/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/aioweb/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/aioweb/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/aioweb/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/aioweb/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/aioweb/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/aioweb/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/aioweb/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/aioweb/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/aioweb/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/aioweb/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/aioweb/deployments",
  "created_at": "2014-10-08T12:02:16Z",
  "updated_at": "2021-09-19T19:24:53Z",
  "pushed_at": "2014-10-08T13:47:40Z",
  "git_url": "git://github.com/bradtraversy/aioweb.git",
  "ssh_url": "git@github.com:bradtraversy/aioweb.git",
  "clone_url": "https://github.com/bradtraversy/aioweb.git",
  "svn_url": "https://github.com/bradtraversy/aioweb",
  "homepage": null,
  "size": 952,
  "stargazers_count": 9,
  "watchers_count": 9,
  "language": "PHP",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 10,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": {
  "key": "gpl-3.0",
  "name": "GNU General Public License v3.0",
  "spdx_id": "GPL-3.0",
  "url": "https://api.github.com/licenses/gpl-3.0",
  "node_id": "MDc6TGljZW5zZTk="
  },
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 10,
  "open_issues": 2,
  "watchers": 9,
  "default_branch": "master"
  },
  {
  "id": 229453338,
  "node_id": "MDEwOlJlcG9zaXRvcnkyMjk0NTMzMzg=",
  "name": "alexis_speech_assistant",
  "full_name": "bradtraversy/alexis_speech_assistant",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/alexis_speech_assistant",
  "description": "Python speech assist app",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant",
  "forks_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/alexis_speech_assistant/deployments",
  "created_at": "2019-12-21T16:23:53Z",
  "updated_at": "2021-11-26T22:43:11Z",
  "pushed_at": "2021-07-10T12:34:40Z",
  "git_url": "git://github.com/bradtraversy/alexis_speech_assistant.git",
  "ssh_url": "git@github.com:bradtraversy/alexis_speech_assistant.git",
  "clone_url": "https://github.com/bradtraversy/alexis_speech_assistant.git",
  "svn_url": "https://github.com/bradtraversy/alexis_speech_assistant",
  "homepage": null,
  "size": 21,
  "stargazers_count": 242,
  "watchers_count": 242,
  "language": "Python",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 171,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 25,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 171,
  "open_issues": 25,
  "watchers": 242,
  "default_branch": "master"
  },
  {
  "id": 364923917,
  "node_id": "MDEwOlJlcG9zaXRvcnkzNjQ5MjM5MTc=",
  "name": "angular-crash-2021",
  "full_name": "bradtraversy/angular-crash-2021",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/angular-crash-2021",
  "description": "Task tracker app from the 2021 youtube crash course",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/angular-crash-2021",
  "forks_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/angular-crash-2021/deployments",
  "created_at": "2021-05-06T13:41:10Z",
  "updated_at": "2021-11-27T14:34:22Z",
  "pushed_at": "2021-11-25T12:11:36Z",
  "git_url": "git://github.com/bradtraversy/angular-crash-2021.git",
  "ssh_url": "git@github.com:bradtraversy/angular-crash-2021.git",
  "clone_url": "https://github.com/bradtraversy/angular-crash-2021.git",
  "svn_url": "https://github.com/bradtraversy/angular-crash-2021",
  "homepage": null,
  "size": 318,
  "stargazers_count": 257,
  "watchers_count": 257,
  "language": "TypeScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 363,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 363,
  "open_issues": 2,
  "watchers": 257,
  "default_branch": "main"
  },
  {
  "id": 167179237,
  "node_id": "MDEwOlJlcG9zaXRvcnkxNjcxNzkyMzc=",
  "name": "angular-crash-todolist",
  "full_name": "bradtraversy/angular-crash-todolist",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/angular-crash-todolist",
  "description": "Simple app for Angular crash course",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist",
  "forks_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/angular-crash-todolist/deployments",
  "created_at": "2019-01-23T12:25:21Z",
  "updated_at": "2021-09-20T16:08:29Z",
  "pushed_at": "2021-01-18T07:07:04Z",
  "git_url": "git://github.com/bradtraversy/angular-crash-todolist.git",
  "ssh_url": "git@github.com:bradtraversy/angular-crash-todolist.git",
  "clone_url": "https://github.com/bradtraversy/angular-crash-todolist.git",
  "svn_url": "https://github.com/bradtraversy/angular-crash-todolist",
  "homepage": null,
  "size": 112,
  "stargazers_count": 220,
  "watchers_count": 220,
  "language": "TypeScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 231,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 231,
  "open_issues": 2,
  "watchers": 220,
  "default_branch": "master"
  },
  {
  "id": 77139096,
  "node_id": "MDEwOlJlcG9zaXRvcnk3NzEzOTA5Ng==",
  "name": "angular60",
  "full_name": "bradtraversy/angular60",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/angular60",
  "description": "Angular in 60 minutes tutorial project",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/angular60",
  "forks_url": "https://api.github.com/repos/bradtraversy/angular60/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/angular60/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/angular60/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/angular60/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/angular60/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/angular60/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/angular60/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/angular60/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/angular60/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/angular60/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/angular60/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/angular60/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/angular60/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/angular60/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/angular60/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/angular60/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/angular60/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/angular60/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/angular60/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/angular60/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/angular60/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/angular60/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/angular60/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/angular60/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/angular60/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/angular60/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/angular60/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/angular60/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/angular60/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/angular60/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/angular60/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/angular60/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/angular60/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/angular60/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/angular60/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/angular60/deployments",
  "created_at": "2016-12-22T11:27:01Z",
  "updated_at": "2021-09-21T07:25:36Z",
  "pushed_at": "2017-03-17T11:58:42Z",
  "git_url": "git://github.com/bradtraversy/angular60.git",
  "ssh_url": "git@github.com:bradtraversy/angular60.git",
  "clone_url": "https://github.com/bradtraversy/angular60.git",
  "svn_url": "https://github.com/bradtraversy/angular60",
  "homepage": null,
  "size": 17,
  "stargazers_count": 127,
  "watchers_count": 127,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 102,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 3,
  "license": {
  "key": "mit",
  "name": "MIT License",
  "spdx_id": "MIT",
  "url": "https://api.github.com/licenses/mit",
  "node_id": "MDc6TGljZW5zZTEz"
  },
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 102,
  "open_issues": 3,
  "watchers": 127,
  "default_branch": "master"
  },
  {
  "id": 108591272,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMDg1OTEyNzI=",
  "name": "angularfs",
  "full_name": "bradtraversy/angularfs",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/angularfs",
  "description": "Simple Angular and FireStore app",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/angularfs",
  "forks_url": "https://api.github.com/repos/bradtraversy/angularfs/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/angularfs/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/angularfs/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/angularfs/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/angularfs/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/angularfs/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/angularfs/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/angularfs/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/angularfs/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/angularfs/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/angularfs/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/angularfs/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/angularfs/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/angularfs/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/angularfs/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/angularfs/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/angularfs/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/angularfs/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/angularfs/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/angularfs/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/angularfs/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/angularfs/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/angularfs/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/angularfs/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/angularfs/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/angularfs/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/angularfs/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/angularfs/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/angularfs/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/angularfs/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/angularfs/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/angularfs/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/angularfs/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/angularfs/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/angularfs/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/angularfs/deployments",
  "created_at": "2017-10-27T20:10:40Z",
  "updated_at": "2021-11-16T15:16:21Z",
  "pushed_at": "2017-11-19T03:59:55Z",
  "git_url": "git://github.com/bradtraversy/angularfs.git",
  "ssh_url": "git@github.com:bradtraversy/angularfs.git",
  "clone_url": "https://github.com/bradtraversy/angularfs.git",
  "svn_url": "https://github.com/bradtraversy/angularfs",
  "homepage": null,
  "size": 16,
  "stargazers_count": 52,
  "watchers_count": 52,
  "language": "TypeScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 41,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 5,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 41,
  "open_issues": 5,
  "watchers": 52,
  "default_branch": "master"
  },
  {
  "id": 102620609,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMDI2MjA2MDk=",
  "name": "animiesample",
  "full_name": "bradtraversy/animiesample",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/animiesample",
  "description": "Sample of an app built with the Anime JavaScript Animation engine",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/animiesample",
  "forks_url": "https://api.github.com/repos/bradtraversy/animiesample/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/animiesample/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/animiesample/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/animiesample/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/animiesample/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/animiesample/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/animiesample/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/animiesample/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/animiesample/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/animiesample/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/animiesample/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/animiesample/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/animiesample/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/animiesample/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/animiesample/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/animiesample/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/animiesample/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/animiesample/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/animiesample/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/animiesample/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/animiesample/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/animiesample/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/animiesample/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/animiesample/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/animiesample/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/animiesample/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/animiesample/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/animiesample/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/animiesample/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/animiesample/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/animiesample/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/animiesample/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/animiesample/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/animiesample/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/animiesample/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/animiesample/deployments",
  "created_at": "2017-09-06T14:43:51Z",
  "updated_at": "2021-09-19T19:24:56Z",
  "pushed_at": "2017-09-06T14:45:12Z",
  "git_url": "git://github.com/bradtraversy/animiesample.git",
  "ssh_url": "git@github.com:bradtraversy/animiesample.git",
  "clone_url": "https://github.com/bradtraversy/animiesample.git",
  "svn_url": "https://github.com/bradtraversy/animiesample",
  "homepage": null,
  "size": 1,
  "stargazers_count": 16,
  "watchers_count": 16,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 15,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 15,
  "open_issues": 0,
  "watchers": 16,
  "default_branch": "master"
  },
  {
  "id": 201106053,
  "node_id": "MDEwOlJlcG9zaXRvcnkyMDExMDYwNTM=",
  "name": "apex-legends-tracker",
  "full_name": "bradtraversy/apex-legends-tracker",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/apex-legends-tracker",
  "description": "App to get Apex Legends stats",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker",
  "forks_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/apex-legends-tracker/deployments",
  "created_at": "2019-08-07T18:27:01Z",
  "updated_at": "2021-11-23T12:16:21Z",
  "pushed_at": "2021-10-06T15:01:25Z",
  "git_url": "git://github.com/bradtraversy/apex-legends-tracker.git",
  "ssh_url": "git@github.com:bradtraversy/apex-legends-tracker.git",
  "clone_url": "https://github.com/bradtraversy/apex-legends-tracker.git",
  "svn_url": "https://github.com/bradtraversy/apex-legends-tracker",
  "homepage": null,
  "size": 1353,
  "stargazers_count": 114,
  "watchers_count": 114,
  "language": "Vue",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 18,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 3,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 18,
  "open_issues": 3,
  "watchers": 114,
  "default_branch": "master"
  },
  {
  "id": 100520910,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMDA1MjA5MTA=",
  "name": "articlebase",
  "full_name": "bradtraversy/articlebase",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/articlebase",
  "description": "Sails.js and mongodb article manager",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/articlebase",
  "forks_url": "https://api.github.com/repos/bradtraversy/articlebase/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/articlebase/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/articlebase/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/articlebase/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/articlebase/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/articlebase/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/articlebase/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/articlebase/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/articlebase/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/articlebase/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/articlebase/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/articlebase/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/articlebase/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/articlebase/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/articlebase/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/articlebase/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/articlebase/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/articlebase/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/articlebase/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/articlebase/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/articlebase/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/articlebase/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/articlebase/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/articlebase/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/articlebase/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/articlebase/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/articlebase/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/articlebase/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/articlebase/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/articlebase/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/articlebase/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/articlebase/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/articlebase/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/articlebase/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/articlebase/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/articlebase/deployments",
  "created_at": "2017-08-16T18:38:35Z",
  "updated_at": "2021-09-19T19:24:57Z",
  "pushed_at": "2019-11-02T16:40:34Z",
  "git_url": "git://github.com/bradtraversy/articlebase.git",
  "ssh_url": "git@github.com:bradtraversy/articlebase.git",
  "clone_url": "https://github.com/bradtraversy/articlebase.git",
  "svn_url": "https://github.com/bradtraversy/articlebase",
  "homepage": null,
  "size": 131,
  "stargazers_count": 32,
  "watchers_count": 32,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 22,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 22,
  "open_issues": 0,
  "watchers": 32,
  "default_branch": "master"
  },
  {
  "id": 112102058,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMTIxMDIwNTg=",
  "name": "aurelia_customer_manager",
  "full_name": "bradtraversy/aurelia_customer_manager",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/aurelia_customer_manager",
  "description": "Simple customer manager app using Aurelia and local storage",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager",
  "forks_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/aurelia_customer_manager/deployments",
  "created_at": "2017-11-26T17:23:17Z",
  "updated_at": "2021-09-19T19:24:57Z",
  "pushed_at": "2017-11-26T17:24:51Z",
  "git_url": "git://github.com/bradtraversy/aurelia_customer_manager.git",
  "ssh_url": "git@github.com:bradtraversy/aurelia_customer_manager.git",
  "clone_url": "https://github.com/bradtraversy/aurelia_customer_manager.git",
  "svn_url": "https://github.com/bradtraversy/aurelia_customer_manager",
  "homepage": null,
  "size": 666,
  "stargazers_count": 7,
  "watchers_count": 7,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 5,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 5,
  "open_issues": 0,
  "watchers": 7,
  "default_branch": "master"
  },
  {
  "id": 217535155,
  "node_id": "MDEwOlJlcG9zaXRvcnkyMTc1MzUxNTU=",
  "name": "axios-crash",
  "full_name": "bradtraversy/axios-crash",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/axios-crash",
  "description": "Axios crash course files",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/axios-crash",
  "forks_url": "https://api.github.com/repos/bradtraversy/axios-crash/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/axios-crash/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/axios-crash/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/axios-crash/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/axios-crash/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/axios-crash/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/axios-crash/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/axios-crash/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/axios-crash/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/axios-crash/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/axios-crash/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/axios-crash/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/axios-crash/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/axios-crash/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/axios-crash/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/axios-crash/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/axios-crash/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/axios-crash/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/axios-crash/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/axios-crash/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/axios-crash/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/axios-crash/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/axios-crash/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/axios-crash/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/axios-crash/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/axios-crash/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/axios-crash/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/axios-crash/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/axios-crash/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/axios-crash/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/axios-crash/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/axios-crash/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/axios-crash/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/axios-crash/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/axios-crash/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/axios-crash/deployments",
  "created_at": "2019-10-25T13:04:36Z",
  "updated_at": "2021-11-15T13:23:20Z",
  "pushed_at": "2019-10-25T13:06:47Z",
  "git_url": "git://github.com/bradtraversy/axios-crash.git",
  "ssh_url": "git@github.com:bradtraversy/axios-crash.git",
  "clone_url": "https://github.com/bradtraversy/axios-crash.git",
  "svn_url": "https://github.com/bradtraversy/axios-crash",
  "homepage": null,
  "size": 3,
  "stargazers_count": 214,
  "watchers_count": 214,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 258,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 258,
  "open_issues": 0,
  "watchers": 214,
  "default_branch": "master"
  },
  {
  "id": 112221349,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMTIyMjEzNDk=",
  "name": "babel_webpack_starter",
  "full_name": "bradtraversy/babel_webpack_starter",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/babel_webpack_starter",
  "description": "Starter pack for ES6+ applications using Webpack and Babel",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter",
  "forks_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/babel_webpack_starter/deployments",
  "created_at": "2017-11-27T16:37:39Z",
  "updated_at": "2021-11-09T21:00:24Z",
  "pushed_at": "2021-10-05T19:34:33Z",
  "git_url": "git://github.com/bradtraversy/babel_webpack_starter.git",
  "ssh_url": "git@github.com:bradtraversy/babel_webpack_starter.git",
  "clone_url": "https://github.com/bradtraversy/babel_webpack_starter.git",
  "svn_url": "https://github.com/bradtraversy/babel_webpack_starter",
  "homepage": null,
  "size": 754,
  "stargazers_count": 300,
  "watchers_count": 300,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 165,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 12,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 165,
  "open_issues": 12,
  "watchers": 300,
  "default_branch": "master"
  },
  {
  "id": 47503742,
  "node_id": "MDEwOlJlcG9zaXRvcnk0NzUwMzc0Mg==",
  "name": "barchart",
  "full_name": "bradtraversy/barchart",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/barchart",
  "description": "A simple bar chart created with the D3 JavaScript library",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/barchart",
  "forks_url": "https://api.github.com/repos/bradtraversy/barchart/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/barchart/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/barchart/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/barchart/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/barchart/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/barchart/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/barchart/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/barchart/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/barchart/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/barchart/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/barchart/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/barchart/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/barchart/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/barchart/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/barchart/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/barchart/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/barchart/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/barchart/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/barchart/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/barchart/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/barchart/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/barchart/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/barchart/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/barchart/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/barchart/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/barchart/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/barchart/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/barchart/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/barchart/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/barchart/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/barchart/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/barchart/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/barchart/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/barchart/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/barchart/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/barchart/deployments",
  "created_at": "2015-12-06T16:09:32Z",
  "updated_at": "2021-09-19T19:25:00Z",
  "pushed_at": "2015-12-06T16:12:35Z",
  "git_url": "git://github.com/bradtraversy/barchart.git",
  "ssh_url": "git@github.com:bradtraversy/barchart.git",
  "clone_url": "https://github.com/bradtraversy/barchart.git",
  "svn_url": "https://github.com/bradtraversy/barchart",
  "homepage": null,
  "size": 1,
  "stargazers_count": 10,
  "watchers_count": 10,
  "language": "HTML",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 9,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 9,
  "open_issues": 0,
  "watchers": 10,
  "default_branch": "master"
  },
  {
  "id": 35898671,
  "node_id": "MDEwOlJlcG9zaXRvcnkzNTg5ODY3MQ==",
  "name": "basicphonegap",
  "full_name": "bradtraversy/basicphonegap",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/basicphonegap",
  "description": "Very simple company mobile app",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/basicphonegap",
  "forks_url": "https://api.github.com/repos/bradtraversy/basicphonegap/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/basicphonegap/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/basicphonegap/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/basicphonegap/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/basicphonegap/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/basicphonegap/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/basicphonegap/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/basicphonegap/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/basicphonegap/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/basicphonegap/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/basicphonegap/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/basicphonegap/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/basicphonegap/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/basicphonegap/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/basicphonegap/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/basicphonegap/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/basicphonegap/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/basicphonegap/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/basicphonegap/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/basicphonegap/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/basicphonegap/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/basicphonegap/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/basicphonegap/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/basicphonegap/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/basicphonegap/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/basicphonegap/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/basicphonegap/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/basicphonegap/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/basicphonegap/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/basicphonegap/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/basicphonegap/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/basicphonegap/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/basicphonegap/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/basicphonegap/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/basicphonegap/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/basicphonegap/deployments",
  "created_at": "2015-05-19T17:49:38Z",
  "updated_at": "2021-09-19T19:25:01Z",
  "pushed_at": "2015-05-19T17:52:40Z",
  "git_url": "git://github.com/bradtraversy/basicphonegap.git",
  "ssh_url": "git@github.com:bradtraversy/basicphonegap.git",
  "clone_url": "https://github.com/bradtraversy/basicphonegap.git",
  "svn_url": "https://github.com/bradtraversy/basicphonegap",
  "homepage": null,
  "size": 1680,
  "stargazers_count": 5,
  "watchers_count": 5,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 5,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 5,
  "open_issues": 0,
  "watchers": 5,
  "default_branch": "master"
  },
  {
  "id": 428783762,
  "node_id": "R_kgDOGY64kg",
  "name": "bcc-home-page",
  "full_name": "bradtraversy/bcc-home-page",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bcc-home-page",
  "description": "New home page for Blue Collar Coder",
  "fork": true,
  "url": "https://api.github.com/repos/bradtraversy/bcc-home-page",
  "forks_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bcc-home-page/deployments",
  "created_at": "2021-11-16T19:14:16Z",
  "updated_at": "2021-11-16T19:14:17Z",
  "pushed_at": "2021-11-13T03:55:04Z",
  "git_url": "git://github.com/bradtraversy/bcc-home-page.git",
  "ssh_url": "git@github.com:bradtraversy/bcc-home-page.git",
  "clone_url": "https://github.com/bradtraversy/bcc-home-page.git",
  "svn_url": "https://github.com/bradtraversy/bcc-home-page",
  "homepage": null,
  "size": 250,
  "stargazers_count": 0,
  "watchers_count": 0,
  "language": null,
  "has_issues": false,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 0,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 0,
  "open_issues": 0,
  "watchers": 0,
  "default_branch": "main"
  },
  {
  "id": 118180142,
  "node_id": "MDEwOlJlcG9zaXRvcnkxMTgxODAxNDI=",
  "name": "bitzprice",
  "full_name": "bradtraversy/bitzprice",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bitzprice",
  "description": "React Next.js app to show current Bitcoin price",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bitzprice",
  "forks_url": "https://api.github.com/repos/bradtraversy/bitzprice/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bitzprice/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bitzprice/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bitzprice/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bitzprice/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bitzprice/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bitzprice/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bitzprice/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bitzprice/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bitzprice/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bitzprice/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bitzprice/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bitzprice/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bitzprice/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bitzprice/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bitzprice/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bitzprice/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bitzprice/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bitzprice/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bitzprice/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bitzprice/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bitzprice/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bitzprice/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bitzprice/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bitzprice/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bitzprice/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bitzprice/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bitzprice/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bitzprice/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bitzprice/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bitzprice/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bitzprice/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bitzprice/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bitzprice/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bitzprice/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bitzprice/deployments",
  "created_at": "2018-01-19T21:24:27Z",
  "updated_at": "2021-11-24T05:46:27Z",
  "pushed_at": "2018-07-19T11:25:49Z",
  "git_url": "git://github.com/bradtraversy/bitzprice.git",
  "ssh_url": "git@github.com:bradtraversy/bitzprice.git",
  "clone_url": "https://github.com/bradtraversy/bitzprice.git",
  "svn_url": "https://github.com/bradtraversy/bitzprice",
  "homepage": null,
  "size": 53,
  "stargazers_count": 106,
  "watchers_count": 106,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 64,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 64,
  "open_issues": 0,
  "watchers": 106,
  "default_branch": "master"
  },
  {
  "id": 74058128,
  "node_id": "MDEwOlJlcG9zaXRvcnk3NDA1ODEyOA==",
  "name": "bizlight_theme",
  "full_name": "bradtraversy/bizlight_theme",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bizlight_theme",
  "description": "Custom Twitter Bootstrap theme that uses bootstrap-sass",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bizlight_theme",
  "forks_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bizlight_theme/deployments",
  "created_at": "2016-11-17T19:03:32Z",
  "updated_at": "2021-11-26T19:29:49Z",
  "pushed_at": "2016-11-17T19:04:10Z",
  "git_url": "git://github.com/bradtraversy/bizlight_theme.git",
  "ssh_url": "git@github.com:bradtraversy/bizlight_theme.git",
  "clone_url": "https://github.com/bradtraversy/bizlight_theme.git",
  "svn_url": "https://github.com/bradtraversy/bizlight_theme",
  "homepage": null,
  "size": 1607,
  "stargazers_count": 40,
  "watchers_count": 40,
  "language": "CSS",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 19,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 1,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 19,
  "open_issues": 1,
  "watchers": 40,
  "default_branch": "master"
  },
  {
  "id": 78652799,
  "node_id": "MDEwOlJlcG9zaXRvcnk3ODY1Mjc5OQ==",
  "name": "bookmarker",
  "full_name": "bradtraversy/bookmarker",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bookmarker",
  "description": "Website bookmarker app built with pure JavaScript",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bookmarker",
  "forks_url": "https://api.github.com/repos/bradtraversy/bookmarker/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bookmarker/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bookmarker/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bookmarker/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bookmarker/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bookmarker/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bookmarker/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bookmarker/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bookmarker/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bookmarker/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bookmarker/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bookmarker/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bookmarker/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bookmarker/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bookmarker/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bookmarker/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bookmarker/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bookmarker/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bookmarker/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bookmarker/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bookmarker/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bookmarker/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bookmarker/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bookmarker/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bookmarker/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bookmarker/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bookmarker/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bookmarker/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bookmarker/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bookmarker/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bookmarker/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bookmarker/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bookmarker/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bookmarker/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bookmarker/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bookmarker/deployments",
  "created_at": "2017-01-11T15:36:43Z",
  "updated_at": "2021-11-18T19:15:51Z",
  "pushed_at": "2019-01-09T13:05:43Z",
  "git_url": "git://github.com/bradtraversy/bookmarker.git",
  "ssh_url": "git@github.com:bradtraversy/bookmarker.git",
  "clone_url": "https://github.com/bradtraversy/bookmarker.git",
  "svn_url": "https://github.com/bradtraversy/bookmarker",
  "homepage": null,
  "size": 144,
  "stargazers_count": 147,
  "watchers_count": 147,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 115,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 4,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 115,
  "open_issues": 4,
  "watchers": 147,
  "default_branch": "master"
  },
  {
  "id": 43564124,
  "node_id": "MDEwOlJlcG9zaXRvcnk0MzU2NDEyNA==",
  "name": "bookstore",
  "full_name": "bradtraversy/bookstore",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bookstore",
  "description": "Simple RESTful JSON api using Nodejs, Express and MongoDB",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bookstore",
  "forks_url": "https://api.github.com/repos/bradtraversy/bookstore/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bookstore/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bookstore/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bookstore/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bookstore/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bookstore/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bookstore/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bookstore/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bookstore/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bookstore/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bookstore/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bookstore/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bookstore/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bookstore/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bookstore/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bookstore/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bookstore/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bookstore/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bookstore/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bookstore/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bookstore/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bookstore/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bookstore/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bookstore/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bookstore/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bookstore/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bookstore/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bookstore/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bookstore/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bookstore/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bookstore/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bookstore/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bookstore/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bookstore/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bookstore/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bookstore/deployments",
  "created_at": "2015-10-02T16:34:56Z",
  "updated_at": "2021-11-13T09:49:04Z",
  "pushed_at": "2019-04-03T12:56:54Z",
  "git_url": "git://github.com/bradtraversy/bookstore.git",
  "ssh_url": "git@github.com:bradtraversy/bookstore.git",
  "clone_url": "https://github.com/bradtraversy/bookstore.git",
  "svn_url": "https://github.com/bradtraversy/bookstore",
  "homepage": null,
  "size": 2667,
  "stargazers_count": 223,
  "watchers_count": 223,
  "language": "HTML",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 209,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 6,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 209,
  "open_issues": 6,
  "watchers": 223,
  "default_branch": "master"
  },
  {
  "id": 25117907,
  "node_id": "MDEwOlJlcG9zaXRvcnkyNTExNzkwNw==",
  "name": "bootsassy",
  "full_name": "bradtraversy/bootsassy",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bootsassy",
  "description": "Bootsassy is an HTML5/CSS framework that sits on top of Bootstrap. Use the .scss files to customize further than the basic Bootstrap styles.",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bootsassy",
  "forks_url": "https://api.github.com/repos/bradtraversy/bootsassy/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bootsassy/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bootsassy/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bootsassy/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bootsassy/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bootsassy/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bootsassy/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bootsassy/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bootsassy/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bootsassy/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bootsassy/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bootsassy/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bootsassy/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bootsassy/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bootsassy/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bootsassy/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bootsassy/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bootsassy/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bootsassy/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bootsassy/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bootsassy/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bootsassy/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bootsassy/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bootsassy/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bootsassy/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bootsassy/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bootsassy/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bootsassy/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bootsassy/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bootsassy/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bootsassy/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bootsassy/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bootsassy/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bootsassy/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bootsassy/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bootsassy/deployments",
  "created_at": "2014-10-12T11:50:26Z",
  "updated_at": "2021-09-19T19:25:04Z",
  "pushed_at": "2014-10-14T20:25:14Z",
  "git_url": "git://github.com/bradtraversy/bootsassy.git",
  "ssh_url": "git@github.com:bradtraversy/bootsassy.git",
  "clone_url": "https://github.com/bradtraversy/bootsassy.git",
  "svn_url": "https://github.com/bradtraversy/bootsassy",
  "homepage": null,
  "size": 3528,
  "stargazers_count": 4,
  "watchers_count": 4,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 3,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 1,
  "license": {
  "key": "gpl-2.0",
  "name": "GNU General Public License v2.0",
  "spdx_id": "GPL-2.0",
  "url": "https://api.github.com/licenses/gpl-2.0",
  "node_id": "MDc6TGljZW5zZTg="
  },
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 3,
  "open_issues": 1,
  "watchers": 4,
  "default_branch": "master"
  },
  {
  "id": 375092400,
  "node_id": "MDEwOlJlcG9zaXRvcnkzNzUwOTI0MDA=",
  "name": "bootstrap-bootcamp-website",
  "full_name": "bradtraversy/bootstrap-bootcamp-website",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bootstrap-bootcamp-website",
  "description": null,
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website",
  "forks_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bootstrap-bootcamp-website/deployments",
  "created_at": "2021-06-08T17:30:00Z",
  "updated_at": "2021-11-24T15:35:59Z",
  "pushed_at": "2021-10-01T00:25:50Z",
  "git_url": "git://github.com/bradtraversy/bootstrap-bootcamp-website.git",
  "ssh_url": "git@github.com:bradtraversy/bootstrap-bootcamp-website.git",
  "clone_url": "https://github.com/bradtraversy/bootstrap-bootcamp-website.git",
  "svn_url": "https://github.com/bradtraversy/bootstrap-bootcamp-website",
  "homepage": null,
  "size": 31,
  "stargazers_count": 224,
  "watchers_count": 224,
  "language": "HTML",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 170,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 170,
  "open_issues": 2,
  "watchers": 224,
  "default_branch": "main"
  },
  {
  "id": 146318874,
  "node_id": "MDEwOlJlcG9zaXRvcnkxNDYzMTg4NzQ=",
  "name": "brainjs_examples",
  "full_name": "bradtraversy/brainjs_examples",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/brainjs_examples",
  "description": "Some examples of simple machine learning using Brain.js",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/brainjs_examples",
  "forks_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/brainjs_examples/deployments",
  "created_at": "2018-08-27T15:42:06Z",
  "updated_at": "2021-11-13T09:50:29Z",
  "pushed_at": "2018-10-21T13:26:11Z",
  "git_url": "git://github.com/bradtraversy/brainjs_examples.git",
  "ssh_url": "git@github.com:bradtraversy/brainjs_examples.git",
  "clone_url": "https://github.com/bradtraversy/brainjs_examples.git",
  "svn_url": "https://github.com/bradtraversy/brainjs_examples",
  "homepage": null,
  "size": 9,
  "stargazers_count": 90,
  "watchers_count": 90,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 54,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 1,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 54,
  "open_issues": 1,
  "watchers": 90,
  "default_branch": "master"
  },
  {
  "id": 276689002,
  "node_id": "MDEwOlJlcG9zaXRvcnkyNzY2ODkwMDI=",
  "name": "breaking-bad-cast",
  "full_name": "bradtraversy/breaking-bad-cast",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/breaking-bad-cast",
  "description": "App to show cast info for breaking bad",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast",
  "forks_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/breaking-bad-cast/deployments",
  "created_at": "2020-07-02T15:58:09Z",
  "updated_at": "2021-11-13T09:43:31Z",
  "pushed_at": "2021-01-07T21:31:29Z",
  "git_url": "git://github.com/bradtraversy/breaking-bad-cast.git",
  "ssh_url": "git@github.com:bradtraversy/breaking-bad-cast.git",
  "clone_url": "https://github.com/bradtraversy/breaking-bad-cast.git",
  "svn_url": "https://github.com/bradtraversy/breaking-bad-cast",
  "homepage": null,
  "size": 418,
  "stargazers_count": 198,
  "watchers_count": 198,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 138,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 2,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 138,
  "open_issues": 2,
  "watchers": 198,
  "default_branch": "master"
  },
  {
  "id": 241138902,
  "node_id": "MDEwOlJlcG9zaXRvcnkyNDExMzg5MDI=",
  "name": "breakout_desktop_nw",
  "full_name": "bradtraversy/breakout_desktop_nw",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/breakout_desktop_nw",
  "description": "Desktop version of Breakout!",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw",
  "forks_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/breakout_desktop_nw/deployments",
  "created_at": "2020-02-17T15:16:39Z",
  "updated_at": "2021-11-11T15:42:21Z",
  "pushed_at": "2021-05-11T03:33:47Z",
  "git_url": "git://github.com/bradtraversy/breakout_desktop_nw.git",
  "ssh_url": "git@github.com:bradtraversy/breakout_desktop_nw.git",
  "clone_url": "https://github.com/bradtraversy/breakout_desktop_nw.git",
  "svn_url": "https://github.com/bradtraversy/breakout_desktop_nw",
  "homepage": null,
  "size": 125,
  "stargazers_count": 75,
  "watchers_count": 75,
  "language": "JavaScript",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 24,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 5,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 24,
  "open_issues": 5,
  "watchers": 75,
  "default_branch": "master"
  },
  {
  "id": 150337525,
  "node_id": "MDEwOlJlcG9zaXRvcnkxNTAzMzc1MjU=",
  "name": "bs4-sass-starter",
  "full_name": "bradtraversy/bs4-sass-starter",
  "private": false,
  "owner": {
  "login": "bradtraversy",
  "id": 5550850,
  "node_id": "MDQ6VXNlcjU1NTA4NTA=",
  "avatar_url": "https://avatars.githubusercontent.com/u/5550850?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/bradtraversy",
  "html_url": "https://github.com/bradtraversy",
  "followers_url": "https://api.github.com/users/bradtraversy/followers",
  "following_url": "https://api.github.com/users/bradtraversy/following{/other_user}",
  "gists_url": "https://api.github.com/users/bradtraversy/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/bradtraversy/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/bradtraversy/subscriptions",
  "organizations_url": "https://api.github.com/users/bradtraversy/orgs",
  "repos_url": "https://api.github.com/users/bradtraversy/repos",
  "events_url": "https://api.github.com/users/bradtraversy/events{/privacy}",
  "received_events_url": "https://api.github.com/users/bradtraversy/received_events",
  "type": "User",
  "site_admin": false
  },
  "html_url": "https://github.com/bradtraversy/bs4-sass-starter",
  "description": "Starter pack to use Bootstrap 4 and Sass",
  "fork": false,
  "url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter",
  "forks_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/forks",
  "keys_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/keys{/key_id}",
  "collaborators_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/collaborators{/collaborator}",
  "teams_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/teams",
  "hooks_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/hooks",
  "issue_events_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues/events{/number}",
  "events_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/events",
  "assignees_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/assignees{/user}",
  "branches_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/branches{/branch}",
  "tags_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/tags",
  "blobs_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/blobs{/sha}",
  "git_tags_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/tags{/sha}",
  "git_refs_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/refs{/sha}",
  "trees_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/trees{/sha}",
  "statuses_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/statuses/{sha}",
  "languages_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/languages",
  "stargazers_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/stargazers",
  "contributors_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/contributors",
  "subscribers_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/subscribers",
  "subscription_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/subscription",
  "commits_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/commits{/sha}",
  "git_commits_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/git/commits{/sha}",
  "comments_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/comments{/number}",
  "issue_comment_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues/comments{/number}",
  "contents_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/contents/{+path}",
  "compare_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/compare/{base}...{head}",
  "merges_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/merges",
  "archive_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/{archive_format}{/ref}",
  "downloads_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/downloads",
  "issues_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/issues{/number}",
  "pulls_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/pulls{/number}",
  "milestones_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/milestones{/number}",
  "notifications_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/notifications{?since,all,participating}",
  "labels_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/labels{/name}",
  "releases_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/releases{/id}",
  "deployments_url": "https://api.github.com/repos/bradtraversy/bs4-sass-starter/deployments",
  "created_at": "2018-09-25T22:38:02Z",
  "updated_at": "2021-11-26T19:30:03Z",
  "pushed_at": "2018-09-25T23:33:13Z",
  "git_url": "git://github.com/bradtraversy/bs4-sass-starter.git",
  "ssh_url": "git@github.com:bradtraversy/bs4-sass-starter.git",
  "clone_url": "https://github.com/bradtraversy/bs4-sass-starter.git",
  "svn_url": "https://github.com/bradtraversy/bs4-sass-starter",
  "homepage": null,
  "size": 1326,
  "stargazers_count": 43,
  "watchers_count": 43,
  "language": "CSS",
  "has_issues": true,
  "has_projects": true,
  "has_downloads": true,
  "has_wiki": true,
  "has_pages": false,
  "forks_count": 13,
  "mirror_url": null,
  "archived": false,
  "disabled": false,
  "open_issues_count": 0,
  "license": null,
  "allow_forking": true,
  "is_template": false,
  "topics": [],
  "visibility": "public",
  "forks": 13,
  "open_issues": 0,
  "watchers": 43,
  "default_branch": "master"
  }
  ]